import DOMPurify from "dompurify";

export function xoa_dau(str) {
  str = str?.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str?.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str?.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str?.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str?.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str?.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str?.replace(/đ/g, "d");
  str = str?.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str?.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str?.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str?.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str?.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str?.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str?.replace(/Đ/g, "D");
  str = str?.replace(/!/g, "");
  return str;
}

export const sanitize = (html) => ({ __html: DOMPurify.sanitize(html || "") });

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

/** Pick VI (default field) or ENG (*_ENG) based on i18n language, with VI fallback. */
export const getLocalized = (data, field, language = "vi") => {
  if (!data) return "";
  const isVi = String(language || "vi").toLowerCase().startsWith("vi");
  if (isVi) return data[field] || "";
  const eng = data[`${field}_ENG`];
  return eng || data[field] || "";
};
